import { PRIMAL_STRIKE_FEATURE_ID, hasPrimalStrike, primalStrikeDice } from '../../../../shared/rules/druid.mjs';

const LABEL = 'Primal Strike';
const TYPES = [{ id: 'cold', label: 'Cold' }, { id: 'fire', label: 'Fire' }, { id: 'lightning', label: 'Lightning' }, { id: 'thunder', label: 'Thunder' }];
const ineligible = (reasonCode) => ({ status: 'ineligible', featureId: PRIMAL_STRIKE_FEATURE_ID, featureLabel: LABEL, reasonCode });

/**
 * Elemental Fury: Primal Strike (Druid 7, 2d8 at 15): once on each of its turns, a weapon hit can deal an extra 1d8 Cold,
 * Fire, Lightning or Thunder damage. Optional, so it asks; the once-per-turn claim commits with the hit like Divine Strike's.
 */
export const evaluatePrimalStrike = ({ context }) => {
  if (!hasPrimalStrike(context?.attacker?.entity)) return ineligible('no-primal-strike');
  if (context?.roll?.hit === false) return ineligible('not-a-hit');
  if (!context?.attack?.isWeaponAttack) return ineligible('not-weapon-attack');
  const combat = context.combat;
  if (!combat?.campaignId || !Number.isInteger(combat?.turnSequence) || !combat?.activeCombatantId || combat.activeCombatantId !== context.attacker?.combatantId) return ineligible('not-your-turn');
  const previous = combat.turnFeatureUsage?.[context.attacker.combatantId]?.[PRIMAL_STRIKE_FEATURE_ID];
  if (previous?.turnSequence === combat.turnSequence && previous.resolutionId !== context.resolutionId) return ineligible('already-used-this-turn');
  const dice = primalStrikeDice(context.attacker.entity);
  const base = { featureId: PRIMAL_STRIKE_FEATURE_ID, featureLabel: LABEL, reasonCode: 'weapon-hit', components: [], claims: [] };
  return {
    status: 'confirmation-required', ...base,
    decision: {
      id: `${context.resolutionId}:${PRIMAL_STRIKE_FEATURE_ID}`, kind: 'confirm-feature', featureId: PRIMAL_STRIKE_FEATURE_ID,
      resolutionId: context.resolutionId, title: LABEL, label: LABEL, prompt: `Add ${dice}d8 to this hit? Once on each of your turns.`,
      choices: [...TYPES.map(({ id, label }) => ({ id, action: 'apply', label: `${dice}d8 ${label}` })), { id: 'skip', label: 'No' }],
    },
    resolveDecision: (choiceId) => {
      const type = TYPES.find(({ id }) => id === choiceId);
      if (!type) return base;
      return { ...base,
        components: [{ id: PRIMAL_STRIKE_FEATURE_ID, label: LABEL, source: { type: 'feature', featureId: PRIMAL_STRIKE_FEATURE_ID }, dice: { count: dice, sides: 8 }, flat: 0,
          damageType: { mode: 'explicit', value: type.id }, critical: { dice: 'double' } }],
        claims: [{ campaignId: combat.campaignId, combatantId: context.attacker.combatantId, featureId: PRIMAL_STRIKE_FEATURE_ID, turnSequence: combat.turnSequence, resolutionId: context.resolutionId }] };
    },
  };
};
